import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { FormGroup } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class RoutesService {

    baseUrl = `${environment.apis.base}/rutas`;

    constructor(private readonly http: HttpClient) { }

    datatable(page?: number): Observable<Object> {
        let url = this.baseUrl;

        if (typeof page === 'number') {
            url += `?page=${page}`;
        }
        return this.http.get<any>(url);
    }

    show(id: number): Observable<Object> {
        const url = `${this.baseUrl}/${id}`;

        return this.http.get<any>(url);
    }

    createOrUpdate(data: FormGroup, id?: number): Observable<Object> {
        let url = this.baseUrl;

        if (id) {
            url += `/${id}`;
        }

        return this.http.post<any>(url, data.value);
    }

    delete(id: number): Observable<Object> {
        const url = `${this.baseUrl}/${id}`;

        return this.http.delete<any>(url);
    }

    list(filter?: any): Observable<Object> {
        const url = `${this.baseUrl}/list`;

        return this.http.get<any>(url);
    }
}
